import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosButton } from "mosaic-react";
import { CommentOutlined, ModeCommentOutlined } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";
import AuditNoteCloseButton from "./AuditNoteCloseButton";

export default function PushAuditNote(props) {
    const { i18n, params, pushModal, reload } = useGlobalValue();
    const theme = useTheme();
    const { value: cell } = props || {};

    const data = {
        projectId: params.projectId,
        fiscalYear: params.fiscalYear,
        selectedRow: cell.id,
    };

    return (
        <SovosButton
            color={theme.palette.text.secondary}
            startIcon={cell.name === 0 ? <ModeCommentOutlined /> : <CommentOutlined />}
            variant="text"
            tooltipText={i18n`new audit note`}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                pushModal({
                    title: i18n`Audit Note`,
                    data: { ...data },
                    args: {
                        ...params,
                        findingId: cell.id,
                        origin: "F",
                        showAuditNoteHistory: true,
                    },
                    view: "AuditNotesForm",
                    modalType: "audit",
                    customHeaderButton: AuditNoteCloseButton
                })
                    .then(() => reload && reload())
                    .catch(() => ({}));
            }}
        >
            {" "}
            {cell.name}
        </SovosButton>
    );
}
